var siteFooter = vueIfExists({
	mixins: [win.buttonSpinner],
	el: '#site-footer',
	data: {
		email: '',
		subscribed: false,
		errorMessage: '',
		sharedStorage: store.state
	},
	methods: {
		testEmail: function ( email ) {
			email = email.trim();
			return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
		},
		signup: function(event) {
	  		this.errorMessage = this.testEmail(this.email) ? "" : this.i18n.emailNotValid;
	  		if (this.errorMessage) return;
		  	this.startBtnLoader(event.target);
		  	$ajax.post({
				url: win.jsonUrl.subscribeNewsletter,
				params: { email: this.email, lang: this.sharedStorage.locale },
			    scope: this,
			    success: function(json) {
			    	if (json.errorMessage) {
			    		this.errorMessage = json.errorMessage;
			    	} else {
				    	this.subscribed = true;
	    			    this.email = '';
				    }
			    },
			    failed: function(errorType) {
		        	if (!errorType || !this.i18n.errors[errorType]) return 'Sorry, an error occurred';
					this.errorMessage = this.i18n.errors[errorType];
			    },
				always: function() {
	                this.stopBtnLoader(event.target);
				}
		  	});
		}
	}

});
